import { Components, Theme } from '@mui/material';

const MuiListItemText: Components<Theme>['MuiListItemText'] = {
  styleOverrides: {
    root: {
      margin: 0,
    },
  },
};

export default MuiListItemText;
